import React, { useState, useEffect } from 'react';
import BaoModal from './ui/BaoModal';
import Button from './ui/Button';

export default function AppUpdatePrompt() {
    const [worker, setWorker] = useState<ServiceWorker | null>(null);

    useEffect(() => {
        const handleUpdate = (e: Event) => {
            const customEvent = e as CustomEvent;
            setWorker(customEvent.detail.worker);
        };

        window.addEventListener('app-update', handleUpdate);
        return () => window.removeEventListener('app-update', handleUpdate);
    }, []);

    const handleUpdateClick = () => {
        if (worker) {
            worker.postMessage({ type: 'SKIP_WAITING' });
            window.location.reload();
        }
    };

    const dismiss = () => {
        setWorker(null);
    };

    return (
        <BaoModal
            isOpen={!!worker}
            onClose={dismiss}
            panelClassName="relative w-[90%] max-w-sm rounded-[20px] bg-white p-6 shadow-xl text-center mx-auto"
        >
            <button 
                onClick={dismiss} 
                className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 transition-colors"
                aria-label="Dismiss"
            >
                ✕
            </button>

            <div className="mb-4 flex justify-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-3xl text-primary-500 shadow-sm border border-primary-100">
                    🔄
                </div>
            </div>

            <h2 className="mb-2 text-xl font-bold text-slate-900 tracking-tight">
                Update Available
            </h2>
            <p className="mb-6 text-sm text-slate-500 leading-relaxed mx-auto max-w-[280px]">
                A new version of BaoAfrik is ready. Update now to get the latest features and improvements!
            </p>

            <Button
                onClick={handleUpdateClick}
                variant="primary"
                fullWidth
                size="md"
                className="mb-3 font-semibold"
            >
                Update Now
            </Button>

            <button 
                onClick={dismiss} 
                className="w-full rounded-xl border border-slate-200 bg-transparent py-2.5 text-sm font-medium text-slate-500 hover:bg-slate-50 hover:text-slate-700 transition-colors"
            >
                Maybe later
            </button>
        </BaoModal>
    );
}
